<template>
  <section class="settings-card">
    <div class="card-header">
      <div>
        <!-- 文档 49：Ops 视角文案改为"我导入的代理"。
             文档 53 P2-01：scope 未加载时不展示带角色判断的文案，避免短暂错位 -->
        <h2 class="card-title blue">{{ scopeLoaded ? (isOpsRole ? '我导入的代理' : '代理管理') : '代理管理' }}</h2>
        <p class="card-desc">{{ scopeLoaded && isOpsRole ? '只展示归属于当前账号的代理；如需查看其他执行人员的代理，请联系管理员。' : '管理项目关联的代理账号，支持导入和手动分配' }}</p>
      </div>
      <div style="display:flex;gap:10px;align-items:center">
        <!-- 文档 53 P2-01：scope 未加载完成时禁用敏感按钮，避免短暂误展示给非 admin/RD/Ops -->
        <el-button v-if="canManageAgents" type="warning" size="small" @click="exportTemplate">导出代理模板</el-button>
        <el-button v-if="canManageAgents" type="warning" size="small" plain @click="exportAgreements" :loading="exportingAgreements">
          <i class="el-icon-download"></i> 导出廉政协议
        </el-button>
        <el-upload v-if="canManageAgents" :action="uploadUrl" :headers="uploadHeaders" :data="{ projectId: projectId }" :on-success="onImportSuccess" :on-error="onImportError" :show-file-list="false" accept=".xlsx,.xls" style="display:inline-block">
          <el-button type="success" size="small">导入代理</el-button>
        </el-upload>
        <!-- 文档 49 + 53 P2-01：执行角色一期隐藏"分配已有代理"；scope 未加载时也不渲染避免一闪而过的错误入口 -->
        <el-button v-if="canAssignExistingAgents" type="primary" size="small" class="add-btn" @click="showAssignDialog">
          <i class="el-icon-s-custom"></i> 分配已有代理
        </el-button>
      </div>
    </div>
    <div class="member-table-wrap">
      <table class="member-table">
        <thead>
          <tr><th>用户名</th><th>姓名</th><th>手机号</th><th>廉政协议</th><th>加入时间</th><th>操作</th></tr>
        </thead>
        <tbody>
          <tr v-for="a in pagedList" :key="a.id">
            <td>{{ a.username }}</td>
            <td>{{ a.name || '-' }}</td>
            <td class="td-muted">{{ a.phone || '-' }}</td>
            <td>
              <template v-if="a.hasAgreement">
                <el-tag size="mini" type="success" effect="plain">已上传</el-tag>
                <el-button type="text" size="mini" @click="previewAgreement(a)" style="margin-left:8px">查看</el-button>
              </template>
              <el-tag v-else size="mini" type="info" effect="plain">未上传</el-tag>
            </td>
            <td class="td-muted">{{ formatDate(a.createdTime) }}</td>
            <td>
              <el-button v-if="canManageAgents" type="text" size="mini" @click="removeAgent(a)" style="color:#f56c6c"><i class="el-icon-delete"></i> 移除</el-button>
            </td>
          </tr>
          <tr v-if="agents.length === 0">
            <td colspan="6" style="text-align:center;color:#94a3b8;padding:32px 0;">暂无代理</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" v-if="agents.length > pageSize">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="agents.length"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="p => currentPage = p" />
    </div>

    <!-- 廉政协议预览弹窗 -->
    <el-dialog
      :visible.sync="previewVisible"
      width="880px"
      append-to-body
      custom-class="add-member-dialog"
      :show-close="false"
      @close="onPreviewClose">
      <div class="dlg-header">
        <h3 class="dlg-title">{{ previewTitle }}</h3>
        <i class="el-icon-close dlg-close" @click="previewVisible = false"></i>
      </div>
      <div class="dlg-body agreement-preview-body">
        <div v-if="previewIsPdf" class="agreement-preview-frame">
          <iframe v-if="previewUrl" :src="previewUrl" />
        </div>
        <div v-else-if="previewIsImage" class="agreement-preview-image">
          <img :src="previewUrl" @click="imageViewerVisible = true" />
          <p class="agreement-preview-hint">点击图片可放大查看</p>
        </div>
        <div v-else class="agreement-preview-empty">
          <i class="el-icon-document"></i>
          <p>无法预览此类型文件</p>
          <el-button size="small" type="primary" plain @click="openInNewTab">下载查看</el-button>
        </div>
      </div>
    </el-dialog>
    <el-image-viewer
      v-if="imageViewerVisible"
      :url-list="[previewUrl]"
      :z-index="3500"
      :append-to-body="true"
      :on-close="() => imageViewerVisible = false" />


    <!-- 分配代理弹窗 -->
    <el-dialog :visible.sync="assignDialogVisible" width="480px" append-to-body custom-class="add-member-dialog" :show-close="false">
      <div class="dlg-header">
        <h3 class="dlg-title">分配代理</h3>
        <i class="el-icon-close dlg-close" @click="assignDialogVisible = false"></i>
      </div>
      <div class="dlg-body">
        <div class="dlg-section">
          <label class="dlg-label">搜索用户</label>
          <el-input v-model="assignKeyword" placeholder="输入用户名/姓名/手机号" @input="debounceSearch" clearable class="dlg-select" />
        </div>
        <div class="dlg-section" v-if="assignResults.length > 0">
          <label class="dlg-label">搜索结果</label>
          <el-radio-group v-model="assignSelectedUid" style="width:100%">
            <div v-for="u in assignResults" :key="u.uid" style="margin-bottom:8px">
              <el-radio :label="u.uid">{{ u.name }} ({{ u.username }}) {{ u.phone }}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="dlg-footer">
        <el-button @click="assignDialogVisible = false" class="dlg-cancel-btn">取消</el-button>
        <el-button type="primary" @click="doAssign" :disabled="!assignSelectedUid" class="dlg-confirm-btn">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { deleteProjectMember } from '@/app/index/api/project/manager'
import { formatDate, downloadBlob } from './settingsHelpers'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'AgentSection',
  components: { ElImageViewer },
  props: {
    projectId: { type: [String, Number], required: true },
    agents: { type: Array, default: () => [] }
  },
  data() {
    return {
      assignDialogVisible: false,
      assignKeyword: '',
      assignResults: [],
      assignSelectedUid: null,
      exportingAgreements: false,
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      previewExt: '',
      imageViewerVisible: false,
      currentPage: 1,
      pageSize: 10,
      // 文档 51 P2-01：当前用户在该项目下的可见性范围（后端返回）
      myScope: null
    }
  },
  computed: {
    uploadUrl() {
      return (process.env.VUE_APP_BASE_URL || '') + '/ProjectManager/project/importAgents'
    },
    uploadHeaders() {
      return { Authorization: 'Bearer ' + (localStorage.getItem('ACCESS_TOKEN') || '') }
    },
    previewIsPdf() { return this.previewExt === 'pdf' },
    previewIsImage() { return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(this.previewExt) },
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.agents.slice(start, start + this.pageSize)
    },
    // 文档 53 P2-01：项目级角色判断必须等 myScope 加载完成。
    //   未加载时不要回退系统角色——同一用户在不同项目内角色可能不同，
    //   兜底全局角色会让"该项目里的非 Ops 用户"短暂看到 Ops 才有的入口/文案。
    isOpsRole() {
      if (this.myScope && typeof this.myScope.isOps === 'boolean') {
        return this.myScope.isOps
      }
      // myScope 未加载：返回 null 而不是 true/false；模板用 v-if=isOpsRole === true 严格判断
      return null
    },
    canManageAgents () {
      return !!(this.myScope && (this.myScope.isManager === true || this.myScope.isOps === true))
    },
    canAssignExistingAgents () {
      return !!(this.myScope && this.myScope.isManager === true)
    },
    // 文档 53 P2-01：myScope 加载状态，模板用来禁用敏感按钮 / 显示 loading
    scopeLoaded() { return !!this.myScope }
  },
  watch: {
    agents() { this.currentPage = 1 },
    projectId: {
      immediate: true,
      handler(v) { if (v) this.loadMyProjectScope() }
    }
  },
  methods: {
    formatDate,
    // 文档 51 P2-01：拉取当前用户在项目下的角色 / 可见性范围
    async loadMyProjectScope() {
      try {
        const res = await this.axios.get(`/ProjectManager/project/${this.projectId}/myScope`)
        const data = res?.data?.data || res?.data || res || {}
        this.myScope = data && (data.role !== undefined) ? data : null
      } catch { /* 接口失败时保持 myScope=null，不展示项目级敏感操作 */ }
    },
    // 适配项目封装的 axios.get(url, params, options) 签名
    async exportTemplate() {
      try {
        const res = await this.axios.get(
          '/ProjectManager/project/exportAgentTemplate',
          { projectId: this.projectId },
          { responseType: 'blob' }
        )
        downloadBlob(res, '代理导入模板.xlsx')
      } catch (e) { this.$message.error('导出模板失败') }
    },
    async exportAgreements() {
      this.exportingAgreements = true
      try {
        const res = await this.axios.get(
          '/ProjectManager/project/exportAgentAgreements',
          { projectId: this.projectId },
          { responseType: 'blob' }
        )
        const ts = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 14)
        downloadBlob(res, `廉政协议_${ts}.zip`)
      } catch (e) {
        // 后端抛业务错（例：无代理、无协议）时 responseType=blob 下 data 是 Blob
        let msg = '导出失败'
        try {
          const blob = e?.response?.data
          if (blob && blob.text) {
            const text = await blob.text()
            const j = JSON.parse(text)
            msg = j.message || j.errmsg || msg
          }
        } catch (_) { /* ignore */ }
        this.$message.error(msg)
      } finally {
        this.exportingAgreements = false
      }
    },
    previewAgreement(agent) {
      if (!agent.agreementUrl) {
        this.$message.warning('协议文件地址无效')
        return
      }
      const url = agent.agreementUrl
      const cleanPath = (url.split('?')[0] || url).toLowerCase()
      const match = cleanPath.match(/\.([a-z0-9]+)$/)
      this.previewExt = match ? match[1] : ''
      this.previewUrl = url
      this.previewTitle = `${agent.name || agent.username} 的廉政协议`
      this.previewVisible = true
    },
    onPreviewClose() {
      this.previewUrl = ''
      this.previewExt = ''
      this.imageViewerVisible = false
    },
    openInNewTab() {
      if (this.previewUrl) window.open(this.previewUrl, '_blank')
    },
    onImportSuccess(res) {
      const data = res.data || res
      if (data.message || data.created !== undefined) {
        // 文档 49：归属冲突的代理数量在 message 中已提示，这里如有冲突则用 warning 而非 success
        if (data.ownerConflict && data.ownerConflict > 0) {
          this.$message.warning(data.message)
        } else {
          this.$message.success(data.message || `导入完成：新建${data.created || 0}，关联${data.linked || 0}，跳过${data.skipped || 0}`)
        }
        this.$emit('refresh')
      } else { this.$message.error(data.message || '导入失败') }
    },
    onImportError() { this.$message.error('导入失败') },
    showAssignDialog() {
      this.assignKeyword = ''
      this.assignResults = []
      this.assignSelectedUid = null
      this.assignDialogVisible = true
    },
    debounceSearch() {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => this.doSearch(), 300)
    },
    async doSearch() {
      if (!this.assignKeyword) { this.assignResults = []; return }
      // 文档 53 P1-03：搜索接口已加 projectId + 角色边界，必须显式传入项目 ID
      const { data } = await this.axios.get('/ProjectManager/project/searchUsers', {
        params: { projectId: this.projectId, keyword: this.assignKeyword, role: 'agent' }
      })
      this.assignResults = data.data || []
    },
    async doAssign() {
      if (!this.assignSelectedUid) return
      try {
        await this.axios.post('/ProjectManager/project/assignUser', {
          ProjectId: parseInt(this.projectId),
          UserId: this.assignSelectedUid,
          Role: 'agent'
        })
        this.$message.success('分配成功')
        this.assignDialogVisible = false
        this.$emit('refresh')
      } catch (e) { this.$message.error(e.response?.data?.message || '分配失败') }
    },
    removeAgent(row) {
      const name = row.name || row.username || '该成员'
      this.$confirm(`确定要移除 ${name} 吗？`, '提示', { type: 'warning', customClass: 'settings-confirm-dialog' })
        .then(async () => {
          try {
            await deleteProjectMember(row.id)
            this.$message.success('已移除')
            this.$emit('refresh')
          } catch (e) {
            if (e !== 'cancel' && e !== 'close') this.$message.error(e?.data?.message || e?.message || '移除失败')
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.pagination { margin-top: 16px; text-align: right; }
</style>
